"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _constants = require("composer-lib/lib/constants");

var DEFAULTS = {
  accounts: (0, _immutable.List)(),
  accountsRequestStatus: _constants.RequestStatus.UNINITIALIZED,
  email: '',
  importStatus: _constants.RequestStatus.UNINITIALIZED,
  token: null,
  tokenRequestStatus: _constants.RequestStatus.UNINITIALIZED
};

var GoogleDocs = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(GoogleDocs, _Record);

  function GoogleDocs() {
    (0, _classCallCheck2.default)(this, GoogleDocs);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(GoogleDocs).apply(this, arguments));
  }

  (0, _createClass2.default)(GoogleDocs, null, [{
    key: "fromJS",
    value: function fromJS(data) {
      return new GoogleDocs({
        email: data.email,
        importStatus: _constants.RequestStatus.UNINITIALIZED,
        token: data.accessToken,
        tokenRequestStatus: _constants.RequestStatus.SUCCEEDED
      });
    }
  }]);
  return GoogleDocs;
}((0, _immutable.Record)(DEFAULTS));

exports.default = GoogleDocs;
module.exports = exports.default;